import { EYibaoAccountStatus, IYibaoBaseInfo } from '../../types/yibao';
import { computed, Ref } from 'vue';

export function useYibaoApplyStatus<T extends IYibaoBaseInfo>(info: Ref<T>) {
  const accountStatus = computed(() => info.value?.merchantStatus);

  const businessOpening = computed(() => [EYibaoAccountStatus.BUSINESS_OPENING, EYibaoAccountStatus.AGREEMENT_SIGNING].includes(accountStatus.value));
  const pendingSubmit = computed(() => accountStatus.value === EYibaoAccountStatus.PENDING_SUBMIT);
  // const agrementSining = computed(() => accountStatus.value === EYibaoAccountStatus.AGREEMENT_SIGNING);
  const unapplyed = computed(() => !accountStatus.value || accountStatus.value === EYibaoAccountStatus.DRAFT);
  const approvaling = computed(() => [EYibaoAccountStatus.REVIEWING].includes(accountStatus.value));
  const approvalSuccess = computed(() => [EYibaoAccountStatus.COMPLETED].includes(accountStatus.value));
  const approvalFailed = computed(() => accountStatus.value === EYibaoAccountStatus.REVIEW_BACK);

  const statusTitle = computed(() => {
    if (unapplyed.value) return '暂未开通易宝账户';

    if (pendingSubmit.value) return '资料待提交';

    if (approvaling.value) return '资料已提交，审核中...';

    if (approvalFailed.value) return '审核不通过';

    if (businessOpening.value) return '账户开通中...';

    if (approvaling.value) return '待审核';

    // if (agrementSining.value) return '协议待签署';

    if (approvalSuccess.value) return '审核通过';

    return '';
  });

  const statusSubTitle = computed(() => {
    if (approvalFailed.value) return `失败原因：${info.value.merchantStatusRemark || ''}`;

    return '';
  });

  return {
    /** 主状态 */
    statusTitle,
    /** 副状态 */
    statusSubTitle,
    /** 账号状态 */
    accountStatus,
    /** 未开通 */
    unapplyed,
    /** 未完成提交 */
    pendingSubmit,
    /** 待审核 */
    approvaling,
    // /** 协议待签署 */
    // agrementSining,
    /** 已开户（正常） */
    approvalSuccess,
    /** 审核失败 */
    approvalFailed,
  };
}
